
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index88j29XntzH8Aqzx5N2lEcMiTjcCgwXlASefh6PsHaGIMeta } from "/app/app/pages/partnersSeo/index.vue?macro=true";
import { default as indexswb5_zgBcLY2qANjkim7_SZTVlfJBA1_kl_Al8w9HxsMeta } from "/app/app/pages/partnersSeo/legal/index.vue?macro=true";
import { default as indexceDAbsRUmwH1vbwcvVRbT6kTq0pnlGAXF_VyhX93fhIMeta } from "/app/app/pages/partnersSeo/health/index.vue?macro=true";
import { default as indexgVQunRASsodGLMtWN25yyuB5Q70XLYy1OBfm1BLOh24Meta } from "/app/app/pages/partnersSeo/complete/index.vue?macro=true";
import { default as indexnM_uuG0F3apIyFY7tX7iiWPSwQIGz3dTGbbPW37OKcsMeta } from "/app/app/pages/partnersSeo/contacts/index.vue?macro=true";
import { default as indexe1sk8n5PbvTdPkTtW52p2AXzE4O_mtpAwNK46tbXMX0Meta } from "/app/app/pages/partnersSeo/locations/index.vue?macro=true";
import { default as thanks_45for_45choiceDZBD1fnRY2kxP9w6PM3JfL74A_CtXt_ifX2aHul4fP0Meta } from "/app/app/pages/partnersSeo/thanks-for-choice.vue?macro=true";
import { default as _91_46_46_46url_93LR3XbKP4cirxIpnGpklwyG9lrqpMQsofM5o2EUtepyEMeta } from "/app/app/pages/partnersSeo/[...city]/[...url].vue?macro=true";
import { default as internetXvF4UT4kxu5UsXX2ujASRDOiBmHXZWsubLgMlclokf0Meta } from "/app/app/pages/partnersSeo/[...city]/internet.vue?macro=true";
import { default as indexBYWLqYwixS8TcX9Xmp0DPSR2RvQt33v035UkdB7bXmcMeta } from "/app/app/pages/partnersSeo/[...city]/quiz/index.vue?macro=true";
import { default as internet_45tvqQVSQVCw_oECBTB3qLewmE6PAZQAplvcg8h8TtuTWYwMeta } from "/app/app/pages/partnersSeo/[...city]/internet-tv.vue?macro=true";
import { default as _91id_93Ww7bFlToUqRiKqc13u7vaQGrSS_NUjAbM7c_h87EftwMeta } from "/app/app/pages/partnersSeo/[...city]/tariffs/[id].vue?macro=true";
import { default as index60vP_Q3MhFKoqGHOLwt31wOQ1AXJ9Mu9quipA8n_NfEMeta } from "/app/app/pages/partnersSeo/legal/[...query]/index.vue?macro=true";
import { default as quiz_45complete4ERUbJy_8mEKtcNaiK7ekSPFAJGhccxsuTOHHgBN_J0Meta } from "/app/app/pages/partnersSeo/[...city]/quiz-complete.vue?macro=true";
import { default as internet_45mobile3qqc30nQVI_G1XkNBjMKE_kQgTl3kzsN8XPisxJZ7IMMeta } from "/app/app/pages/partnersSeo/[...city]/internet-mobile.vue?macro=true";
import { default as internet_45tv_45mobileyR7eBHAw6m2fZ1SzfcJRwAfkEXE6jAR5otRfy_ubqC0Meta } from "/app/app/pages/partnersSeo/[...city]/internet-tv-mobile.vue?macro=true";
import { default as indexiyxQaVmpAVZT0geWJg_KPG5mfAbxgHU3s1nGGR8GDjkMeta } from "/app/app/pages/partnersSeo/[...city]/not-available/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/partnersSeo/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/app/app/pages/partnersSeo/legal/index.vue")
  },
  {
    name: "health",
    path: "/health",
    meta: indexceDAbsRUmwH1vbwcvVRbT6kTq0pnlGAXF_VyhX93fhIMeta || {},
    component: () => import("/app/app/pages/partnersSeo/health/index.vue")
  },
  {
    name: "complete",
    path: "/complete",
    meta: indexgVQunRASsodGLMtWN25yyuB5Q70XLYy1OBfm1BLOh24Meta || {},
    component: () => import("/app/app/pages/partnersSeo/complete/index.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/app/app/pages/partnersSeo/contacts/index.vue")
  },
  {
    name: "locations",
    path: "/locations",
    component: () => import("/app/app/pages/partnersSeo/locations/index.vue")
  },
  {
    name: "thanks-for-choice",
    path: "/thanks-for-choice",
    meta: thanks_45for_45choiceDZBD1fnRY2kxP9w6PM3JfL74A_CtXt_ifX2aHul4fP0Meta || {},
    component: () => import("/app/app/pages/partnersSeo/thanks-for-choice.vue")
  },
  {
    name: "city-url",
    path: "/:city([^/]*)*/:url(.*)*",
    component: () => import("/app/app/pages/partnersSeo/[...city]/[...url].vue")
  },
  {
    name: "city-internet",
    path: "/:city([^/]*)*/internet",
    component: () => import("/app/app/pages/partnersSeo/[...city]/internet.vue")
  },
  {
    name: "city-quiz",
    path: "/:city([^/]*)*/quiz",
    meta: indexBYWLqYwixS8TcX9Xmp0DPSR2RvQt33v035UkdB7bXmcMeta || {},
    component: () => import("/app/app/pages/partnersSeo/[...city]/quiz/index.vue")
  },
  {
    name: "city-internet-tv",
    path: "/:city([^/]*)*/internet-tv",
    component: () => import("/app/app/pages/partnersSeo/[...city]/internet-tv.vue")
  },
  {
    name: "city-tariffs-id",
    path: "/:city([^/]*)*/tariffs/:id()",
    component: () => import("/app/app/pages/partnersSeo/[...city]/tariffs/[id].vue")
  },
  {
    name: "legal-query",
    path: "/legal/:query(.*)*",
    component: () => import("/app/app/pages/partnersSeo/legal/[...query]/index.vue")
  },
  {
    name: "city-quiz-complete",
    path: "/:city([^/]*)*/quiz-complete",
    meta: quiz_45complete4ERUbJy_8mEKtcNaiK7ekSPFAJGhccxsuTOHHgBN_J0Meta || {},
    component: () => import("/app/app/pages/partnersSeo/[...city]/quiz-complete.vue")
  },
  {
    name: "city-internet-mobile",
    path: "/:city([^/]*)*/internet-mobile",
    component: () => import("/app/app/pages/partnersSeo/[...city]/internet-mobile.vue")
  },
  {
    name: "city-internet-tv-mobile",
    path: "/:city([^/]*)*/internet-tv-mobile",
    component: () => import("/app/app/pages/partnersSeo/[...city]/internet-tv-mobile.vue")
  },
  {
    name: "city-not-available",
    path: "/:city([^/]*)*/not-available",
    component: () => import("/app/app/pages/partnersSeo/[...city]/not-available/index.vue")
  }
]